import { request } from './httpClient';
// Never send exception messages, stack traces, URLs, form fields or API payloads.
export function reportRenderFailure() {
  const raw=import.meta.env.VITE_RELEASE_ID || import.meta.env.MODE;
  const release_id=/^[A-Za-z0-9._-]{1,64}$/.test(raw)?raw:'unknown';
  void request('/auth/client-error',{method:'POST',body:{code:'UI_RENDER_FAILED',release_id}}).catch(()=>{});
}
